import * as React from "react";
import { Container, ContainerFW } from "../global";
import { Heading } from "../Heading";
import { applyTrailingSlashToAnchorHrefs } from "../../utils";
export const FreeText = (props) => {
    const cssClass = `free-text${props.isWarningText ? " free-text--warning" : ""}${props.className ? ` ${props.className}` : ""}`;
    return (React.createElement("div", { className: cssClass, style: { backgroundColor: props.backgroundColor ? props.backgroundColor : "#fff" } },
        React.createElement(ContainerFW, null,
            React.createElement(Container, { className: props.mainWidth === "1400px" ? "g-container--new" : "" },
                props.heading && React.createElement(Heading, { design: "h2-regular", style: { "--title-alignment": props.titleAlignment } }, props.heading),
                React.createElement("div", { className: "free-text__content", dangerouslySetInnerHTML: { __html: applyTrailingSlashToAnchorHrefs(props.content) } })))));
};
